import React, {Component} from 'react';
import {Alert, notification, Button} from 'antd'

export default class UserNotification extends Component {
  constructor(props) {
    super(props);
  }


  render() {
    const inMessage = this.props.inMessage;
    const inDescription = this.props.inDescription;

    return (

        <div>

          {notification.open({message: inMessage, description: inDescription ,duration:0})};

        </div>
      );
  }

}
